import { connect } from 'react-redux';
import CommentUserBanner from './CommentUserBanner';
import { currentUserId as getCurrentUserId } from '../../../../../core/selectors/user';
import {
  accessingCurrentSpaceAsStaff,
  isInstructor,
  isInstructorInSpace,
} from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, ownProps) => {
  const currentUserId = getCurrentUserId(state);
  const spaceId = ownProps.spaceId;
  return {
    // When spaceId is provided (e.g. PostDetailPopup), use the space-specific
    // check so the educator flag is correct from the first render regardless of
    // whether a classroom is currently "active" in the app.
    // When spaceId is NOT provided (legacy callers), fall back to the original
    // isInstructor which uses currentClassRoomId — preserving old behaviour.
    isEducator: spaceId
      ? isInstructorInSpace(state)(currentUserId, spaceId)
      : isInstructor(state, currentUserId),
    // comment.author does not exist in the data structure; the correct field is
    // comment.user.objectId (Parse) or comment.user.id (REST/UUID).
    isAuthor:
      currentUserId ===
      (ownProps.comment?.user?.objectId || ownProps.comment?.user?.id),
    isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
  };
};

const CommentUserBannerContainer = connect(mapStateToProps)(CommentUserBanner);

export default CommentUserBannerContainer;
